import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderDeleteUsersDialog = ({ onActionClick, isBizVariant }: { onActionClick: () => void; isBizVariant?: boolean }) => {
    let title = 'Вы действительно хотите отключить доступ для пользователей Облака?';
    let description = 'После отключения эта папка перестанет быть доступной для приглашённых вами пользователей Облака';

    if (isBizVariant) {
        title = 'Закрыть персональный\nдоступ пользователям Диска?';
        description = 'Папка исчезнет из их Диска. Вы сможете снова ей поделиться, если потребуется';
    }

    openPopupHelper({
        popupName: popupNames.NO_WARNING,
        data: {
            id: 'sharing-warning-dialog',
            onActionClick,
            title,
            description,
            buttonAcceptText: 'Отключить',
            buttonRejectText: 'Не отключать',
            hideCheckbox: isBizVariant,
            compactButtons: isBizVariant,
        },
    });
};
